export default [
  {
    path: '/main/arena/vehicle-type',
    meta: {
      tag: 'list_arena_vehicle_type',
      name: 'Tipo de veículo (Arena)',
      breadcrumb: 'Tipo de veículo (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-vehicle-type-list" */ '@/views/main/settings/arena/vehicle-type/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenavehicletype',
        meta: {
          tag: 'list_arena_vehicle_type',
          menu: 'settings',
          name: 'Tipo de veículo (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-vehicle-type-list" */ '@/views/main/settings/arena/vehicle-type/List.vue'),
      },
      {
        path: '/main/arena/vehicle-type/add',
        name: 'addarenavehicletype',
        meta: {
          tag: 'add_arena_vehicle_type',
          menu: 'settings',
          name: 'Adicionar | Tipo de veículo (Arena)',
          breadcrumb: 'Adicionar Tipo de veículo (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-vehicle-type-add" */ '@/views/main/settings/arena/vehicle-type/Add.vue')
      },
      {
        path: '/main/arena/vehicle-type/:id',
        name: 'editarenavehicletype',
        meta: {
          tag: 'edit_arena_vehicle_type',
          menu: 'settings',
          name: 'Editar | Tipo de veículo (Arena)',
          breadcrumb: 'Editar Tipo de veículo (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-vehicle-type-edit" */ '@/views/main/settings/arena/vehicle-type/Edit.vue')
      }
    ]
  }
]
